import React from "react";
import { Route, Switch } from "react-router";
import { BatchesIndex } from "../../../pages/admin/batches";
import { BatchODEsIndex } from "../../../pages/admin/batches/show/odes";
import {
  EntrepreneursIndex
} from "../../../pages/admin/batches/show/entrepreneurs";
import { ExpertsIndex } from "../../../pages/admin/batches/show/experts";
import {
  CoordinatorsIndex
} from "../../../pages/admin/batches/show/coordinators";
import { BatchODEContent } from "../../../pages/admin/batches/publish/companies/content";
import { BatchBoardIndex } from "../../../pages/admin/batches/show/board";
import { PerksIndex } from "../../../pages/admin/batches/show/perks";
import { TasksIndex } from "../../../pages/admin/batches/show/tasks";
import {
    OdesUpdatesIndex
} from "../../../pages/admin/batches/show/odes-updates";
import { TrainingsIndex } from "../../../pages/admin/batches/show/trainings";
import { CalendarIndex } from "../../../pages/admin/batches/show/calendar";
import { ContentIndex } from "../../../pages/admin/batches/show/content";
import { AnnouncementsIndex } from "../../../pages/admin/batches/show/announcements";
import { AnnouncementsIndexDetail } from "../../../pages/admin/batches/show/announcements/detail";
import { NewBatchInformationUpdateIndex } from "../../../pages/admin/batches/new/information/update";
import {
  NewBatchInformationIndex,
  NewBatchContentIndex,
  NewBatchMembersIndex,
  NewBatchPublishIndex
} from "../../../pages/admin/batches/new";
import { BatchPublishIndex } from "../../../pages/admin/batches/publish";
import {BatchODEContent as DeprecatedBatchODEContent} from "../../../pages/admin/batches/show/odes/show";
import BatchCompaniesProgress from "../../../pages/admin/batches/show/batch-companies-progress";

export const AdminBatchesRoutes = (
  <Switch>
    <Route
      exact
      path="/v2/admin/batches"
      component={BatchesIndex} />
    <Route
      exact
      path="/v2/admin/batches/:id/offer"
      component={BatchPublishIndex} />
    <Route
      exact
      path="/v2/admin/batches/:id/publish/companies/:odeId/content"
      component={BatchODEContent} />
    <Route
      exact
      path="/v2/admin/batches/new"
      component={NewBatchInformationIndex} />
    <Route
      exact
      path="/v2/admin/batches/new/:id"
      component={NewBatchInformationUpdateIndex} />
    <Route
      exact
      path="/v2/admin/batches/new/:id/members"
      component={NewBatchMembersIndex} />
    <Route
      exact
      path="/v2/admin/batches/new/:id/content"
      component={NewBatchContentIndex} />
    <Route
      exact
      path="/v2/admin/batches/new/:id/publish"
      component={NewBatchPublishIndex} />
    <Route
      exact
      path="/v2/admin/batches/:id/odes"
      component={BatchODEsIndex} />
    <Route
      path="/v2/admin/batches/:id/odes/:odeId/content"
      component={DeprecatedBatchODEContent} />
    <Route
      path="/v2/admin/batches/:id/entrepreneurs"
      component={EntrepreneursIndex} />
    <Route
      path="/v2/admin/batches/:id/experts"
      component={ExpertsIndex} />
    <Route
      path="/v2/admin/batches/:id/coordinators"
      component={CoordinatorsIndex} />
    <Route
      path="/v2/admin/batches/:id/board"
      component={BatchBoardIndex} />
    <Route
      path="/v2/admin/batches/:id/perks"
      component={PerksIndex} />
    <Route
      path="/v2/admin/batches/:id/tasks"
      component={TasksIndex} />
    <Route
      path="/v2/admin/batches/:id/odes-updates"
      component={OdesUpdatesIndex} />
    <Route
      path="/v2/admin/batches/:id/trainings"
      component={TrainingsIndex} />
    <Route
      path="/v2/admin/batches/:id/calendar"
      component={CalendarIndex} />
    <Route
      path="/v2/admin/batches/:id/content"
      component={ContentIndex} />
    <Route
      path="/v2/admin/batches/:id/announcements"
      exact={true}
      component={AnnouncementsIndex} />
    <Route
      path="/v2/admin/batches/:id/announcements/:announcementsId"
      component={AnnouncementsIndexDetail} />
    <Route
      path="/v2/admin/batches/:id/batch-companies-progress"
      component={BatchCompaniesProgress} />
  </Switch>
);
